import { css, styled } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const ChangeIndicationContainer = styled(Flex)<{ isIncreasing: boolean; isNotChanged: boolean }>`
    flex-wrap: nowrap;

    ${({ isIncreasing, isNotChanged }) => {
        if (isNotChanged) {
            return css`
                background: ${colorsPalettes.carbon[50]};
            `;
        }

        return isIncreasing
            ? css`
                  background: ${colorsPalettes.green[100]};
              `
            : css`
                  background: ${colorsPalettes.red[100]};
              `;
    }}
    border-radius: 20px;
    padding: 4px 12px 4px 8px;
    align-items: baseline;
`;

export const ChangeValue = styled.p<{ isIncreasing: boolean; isNotChanged: boolean }>`
    ${({ isIncreasing, isNotChanged }) => {
        if (isNotChanged) {
            return setFontVariant("primaryItem", colorsPalettes.carbon[300]);
        }

        return setFontVariant("primaryItem", isIncreasing ? colorsPalettes.green["500"] : colorsPalettes.red["500"]);
    }}

    margin: 0;
    text-wrap: nowrap;
`;

export const ArrowIcon = styled(SWReactIcons)`
    text-align: center;
    margin: 0 4px;
`;
